import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=bbd6e7e4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/home.css?vue&type=style&index=0&id=bbd6e7e4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd6e7e4",
  null
  
)

export default component.exports